import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTopOnRouteChange() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });

    // Setzt den Tastaturfokus nach dem Routenwechsel an den Seitenanfang, damit die Tab-Reihenfolge wieder oben startet
    const target = document.body;
    target.setAttribute('tabindex', '-1'); // tabIndex temporär setzen, damit fokussierbar
    target.focus({ preventScroll: true });
    target.removeAttribute('tabindex');
  }, [pathname]);

  return null;
}

export default ScrollToTopOnRouteChange;
